// extracted by mini-css-extract-plugin
export default {"copyright":"styles_copyright__yDbvj"};